import React, { useState, useEffect } from "react";

/** Components */
import {
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Table,
  Paper,
  TablePagination,
  Checkbox,
  TableFooter,
  ButtonGroup,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Tooltip,
} from "@mui/material";
import ButtonWithAPICallComponent from "../../commons/ButtonWithAPICall.component";
import SelectStatusButton from "../../commons/SelectStatusButton";
import { FilterBy } from "./../../commons/filter.component";
import LoadingProgress from "../../commons/LoadingProgress.component";

/** Icons */
import AddIcon from "@mui/icons-material/Add";

/** Api & Function */
import { createDepartment, updateDepartment, getDepartment, updateDepartmentStatus, getOrganizationData } from "../../../services/api";
import { setHeaderTitle } from "../../../store/layoutSlide";
/** Package */

import { useTranslation } from "react-i18next";
/** Hook */

import { usePagination } from "./../../commons/customHook";
import { useDispatch } from "react-redux";

const Department = () => {
  const [t] = useTranslation();
  const dispatch = useDispatch();

  const [page, setPage, rowsPerPage, setRowsPerPage] = usePagination();
  const [data, setData] = useState(null);
  const [changeIds, setChangeIds] = useState([]); //ids cua nhung invoice can cap nhat
  const [selectedRow, setSelectedRow] = useState(null);

  useEffect(() => {
    dispatch(setHeaderTitle("THÔNG TIN PHÒNG - BAN"));
    getDepartment().then((res) => {
      res.code === 200 && setData(res.data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleCheckBoxClick = (id) => {
    if (changeIds.includes(id)) setChangeIds((prev) => prev.filter((item) => item !== id));
    else setChangeIds((prev) => [...prev, id]);
  };
  const handleUpdateStatus = (selectedStatus) => {
    return updateDepartmentStatus({ ids: changeIds, action: selectedStatus.action });
  };
  const handleUpdateStatusResponse = (res, selectedStatus) => {
    if (res.code === 200) {
      let newStatus;
      switch (selectedStatus.action) {
        case 0:
          newStatus = "DEACTIVATED";
          break;
        case 1:
          newStatus = "ACTIVATED";
          break;
        case 4:
          setChangeIds([]);
          newStatus = "DELETED";
          break;
        default:
          break;
      }
      setData((prev) => prev.map((item) => (changeIds.includes(item.id) ? { ...item, status: newStatus } : item)));
    }
  };
  const handleEditResponse = (res) => {
    if (res.code === 200) {
      setData((prev) => prev.map((item) => (item.id === res.data?.id ? res.data : item)));
    }
  };
  const handleCreateResponse = (res) => {
    if (res.code === 200) {
      setSelectedRow(null);
      setData((prev) => [...prev, res.data]);
    }
  };
  return (
    <div>
      <div align="right" style={{ marginBottom: 10, marginTop: 10, backgroundColor: "#b3deff", height: 40 }}>
        <ButtonGroup style={{ height: 40, marginRight: 10 }}>
          <Button variant="outlined" onClick={() => setSelectedRow(false)}>
            <Tooltip title="Tạo mới">
              <AddIcon />
            </Tooltip>
          </Button>
        </ButtonGroup>
      </div>

      {!data ? (
        <LoadingProgress />
      ) : (
        <TableContainer component={Paper} style={{ width: "98%", marginLeft: 10 }} sx={{ maxHeight: 800 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell style={{ border: "0.5px solid lightgray" }}>ID</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Tổ chức")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Phòng/ban")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Mã phòng/ban")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Trực thuộc")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Số điện thoại")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Trạng thái")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>
                  <SelectStatusButton disabled={!changeIds.length} api={handleUpdateStatus} response={handleUpdateStatusResponse} />
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).length ? (
                data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                  <TableRow key={row.id} hover style={{ cursor: "pointer" }} onClick={(e) => e.target.type !== "checkbox" && setSelectedRow(row)}>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.id} </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.organization_name}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.name}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.code}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.uplevel_department}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.phone}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{t(row.status)}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>
                      <Checkbox disabled={row.status === "DELETED"} checked={changeIds.includes(row.id)} onClick={handleCheckBoxClick.bind(this, row.id)} />
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={50}>{t("Không có dữ liệu")}</TableCell>
                </TableRow>
              )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[10, 25, 100]}
                  count={data.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={(e, newPage) => setPage(newPage)}
                  onRowsPerPageChange={setRowsPerPage}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      )}
      <EditDepartmentForm initialData={selectedRow} onClose={() => setSelectedRow(null)} onSaveResponse={handleEditResponse} />
      <CreateInvoiceForm open={selectedRow === false} onClose={() => setSelectedRow(null)} onCreateResponse={handleCreateResponse} />
    </div>
  );
};

export default Department;

const EditDepartmentForm = ({ initialData, onClose, onSaveResponse }) => {
  const [t] = useTranslation();
  const [inputData, setInputData] = useState({
    name: "",
    code: "",
    organization: null,
    phone: "",
    department: null,
  });

  // method
  const handleSave = () => {
    return updateDepartment(initialData?.id, { ...inputData, department_id: inputData.department?.id, organization_id: inputData.organization?.id });
  };
  // effect
  useEffect(() => {
    if (!initialData) return;
    else setInputData(initialData);
  }, [initialData]);
  return (
    <Dialog open={Boolean(initialData)} onClose={onClose}>
      <DialogTitle align="center">{t("Cập nhật phòng/ban")}</DialogTitle>
      <DialogContent>
        <div style={{ display: "grid", rowGap: 10, marginTop: 10, overflow: "hidden" }}>
          <TextField label={t("Tên")} value={inputData.name} sx={{ width: "300px" }} onChange={(e) => setInputData((prev) => ({ ...prev, name: e.target.value }))} />
          <TextField label={t("Mã")} value={inputData.code} sx={{ width: "300px" }} onChange={(e) => setInputData((prev) => ({ ...prev, code: e.target.value }))} />
          <FilterBy
            getDataFunc={() => getOrganizationData({ params: { status: 1 } })}
            style={{ maxWidth: 400 }}
            label={t("Tổ chức")}
            setDefaultFunc={(option) => setInputData((prev) => ({ ...prev, organization: option.find((item) => initialData.organization_id === item.id) }))}
            triggerSetDefaultFunc={initialData}
            value={inputData.organization}
            onChange={(e, newValue) => setInputData((prev) => ({ ...prev, organization: newValue }))}
          />
          <FilterBy
            getDataFunc={() => getDepartment({ params: { status: 1 } })}
            filter={(option) => option.id !== initialData?.id}
            style={{ maxWidth: 400 }}
            label={t("Phòng ban")}
            value={inputData.department}
            setDefaultFunc={(option) => setInputData((prev) => ({ ...prev, department: option.find((item) => initialData.parent_id === item.id) }))}
            triggerSetDefaultFunc={initialData}
            onChange={(e, newValue) => setInputData((prev) => ({ ...prev, department: newValue }))}
          />
          <TextField label={t("Số điện thoại")} value={inputData.phone} sx={{ width: "300px" }} onChange={(e) => setInputData((prev) => ({ ...prev, phone: e.target.value }))} />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("Hủy")}</Button>
        <ButtonWithAPICallComponent variant="contained" api={handleSave} response={onSaveResponse}>
          {t("Lưu")}
        </ButtonWithAPICallComponent>
      </DialogActions>
    </Dialog>
  );
};

const CreateInvoiceForm = ({ open, onClose, onCreateResponse }) => {
  const [t] = useTranslation();
  const [inputData, setInputData] = useState({
    name: "",
    code: "",
    organization: null,
    phone: "",
    department: null,
  });
  // method
  const handleCreate = () => {
    return createDepartment({ ...inputData, organization_id: inputData.organization?.id, department_id: inputData.department?.id });
  };
  // effect

  return (
    <Dialog open={Boolean(open)} onClose={onClose}>
      <DialogTitle align="center">{t("Tạo phòng/ban")}</DialogTitle>
      <DialogContent>
        <div style={{ display: "grid", rowGap: 10, marginTop: 10, overflow: "hidden" }}>
          <TextField label={t("Tên")} value={inputData.name} sx={{ width: "300px" }} onChange={(e) => setInputData((prev) => ({ ...prev, name: e.target.value }))} />
          <TextField label={t("Mã")} value={inputData.code} sx={{ width: "300px" }} onChange={(e) => setInputData((prev) => ({ ...prev, code: e.target.value }))} />
          <FilterBy
            getDataFunc={() => getOrganizationData({ params: { status: 1 } })}
            style={{ maxWidth: 400 }}
            label={t("Tổ chức")}
            value={inputData.organization}
            onChange={(e, newValue) => setInputData((prev) => ({ ...prev, organization: newValue, organization_id: newValue.id }))}
          />
          <FilterBy
            getDataFunc={() => getDepartment({ params: { status: 1 } })}
            style={{ maxWidth: 400 }}
            label={t("Phòng ban")}
            value={inputData.department}
            onChange={(e, newValue) => setInputData((prev) => ({ ...prev, department: newValue, organization_id: newValue.id }))}
          />
          <TextField label={t("Số điện thoại")} value={inputData.phone} sx={{ width: "300px" }} onChange={(e) => setInputData((prev) => ({ ...prev, phone: e.target.value }))} />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("Hủy")}</Button>
        <ButtonWithAPICallComponent variant="contained" api={handleCreate} response={onCreateResponse}>
          {t("Tạo mới")}
        </ButtonWithAPICallComponent>
      </DialogActions>
    </Dialog>
  );
};
